













































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import { ApplicationDataResponse } from '@/ts/HococoInterfaces';

@Component({
    computed: {
        ...mapGetters({
            reviewApplicationVisible: 'WaitingLists/getIfreviewApplicationVisible',
            applicationState: 'WaitingLists/getPreviewedApplicationState',
            getAvailableApartments: 'WaitingLists/getAvailableApartments',
            selectedApartmentId: 'WaitingLists/getSelectedApartmentId',
        }),
    },
})
export default class PreviewAvailableApartments extends Vue {
    @Prop() public applicationData!: ApplicationDataResponse;

    constructor() {
        super();
    }

    public cancel() {
        this.$store.commit(Mutations.SET_AVAILABLE_APARTMENTS_VISIBILITY, false);
        this.$store.commit(Mutations.SET_PREVIEW_APPLICATION_FORM_VISIBILITY, true);
        this.$store.dispatch(Actions.RESET_ACTIVE_APARTMENT_ROWS, 0);
    }

    public registerApplication(applicationId: number) {
        const apartmentId = this.$store.getters['WaitingLists/getSelectedApartmentId'];

        if (apartmentId) {
            this.$store.dispatch(Actions.ACCEPT_APPLICATION, {applicationId, apartmentId});
        } else {
            alert('You need to select at leaste one apartement');
        }
    }

    public assignApplicationToUnit(applicationId: number) {
        const apartmentId = this.$store.getters['WaitingLists/getSelectedApartmentId'];

        if (apartmentId) {
            this.$store.dispatch(Actions.ASSIGN_UNIT, {applicationId, apartmentId});
        } else {
            alert('You need to select at least one apartment');
        }
    }

    public showAllVacantApartments(ev: any) {
        this.$store.dispatch(Actions.RESET_ACTIVE_APARTMENT_ROWS, 0);
        this.$store.dispatch(Actions.FETCH_ALL_AVAILABLE_APARTMENTS, {id: this.applicationData.id, ignore: ev.srcElement.checked});
    }

    public showHideAccordeon(projectId: number) {
        const iconElem = document.querySelector(`[data-icon-project-id='${ projectId }']`);
        const bodyElems = document.querySelectorAll(`[data-body-project-id='${ projectId }']`);

        if (iconElem.classList.contains('rotate')) {
            iconElem.classList.remove('rotate');
            bodyElems.forEach( (bodyElem) => {
                bodyElem.classList.remove('hide-accordeon');
            });
        } else {
            iconElem.classList.add('rotate');
            bodyElems.forEach(( bodyElem ) => {
                bodyElem.classList.add('hide-accordeon');
            });
        }
    }

    public setSelectedApartment(propertyId: any) {
        this.$store.dispatch(Actions.RESET_ACTIVE_APARTMENT_ROWS, propertyId);
        document.querySelector(`[data-property-id="${propertyId}"]`).classList.add('activeTypeBlockItem');
    }
}
